import { purposeSection } from '@/content/homepage';

/**
 * "Our Model" — three equal editorial pillars (ICONIQ Convene/Collaborate/Co-Fund rhythm).
 */
export function ApproachBand() {
  return (
    <section
      id={purposeSection.id}
      aria-labelledby="purpose-heading"
      className="scroll-mt-24 border-y border-border/70 bg-card py-20 sm:py-28"
    >
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-primary mb-4 text-xs font-semibold tracking-[0.24em] uppercase">
            {purposeSection.eyebrow}
          </p>
          <h2
            id="purpose-heading"
            className="font-display text-foreground text-3xl font-semibold tracking-tight text-balance sm:text-4xl lg:text-[2.75rem] lg:leading-tight"
          >
            {purposeSection.heading}
          </h2>
          <p className="text-muted-foreground mt-6 text-base leading-relaxed sm:text-lg">
            {purposeSection.lead}
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-3 sm:gap-0">
          {purposeSection.pillars.map((pillar, index) => (
            <li
              key={pillar.id}
              className={
                index === 0
                  ? 'flex flex-col gap-4 sm:pr-8'
                  : 'flex flex-col gap-4 border-border/70 sm:border-l sm:px-8 lg:px-10'
              }
            >
              <span className="font-display text-primary text-sm font-semibold tracking-[0.22em]">
                {pillar.index}
              </span>
              <h3 className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-[1.65rem]">
                {pillar.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed sm:text-[0.95rem]">
                {pillar.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
